module.exports = __webpack_public_path__ + "img/lr.a3790fa5.svg";